import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 全域 camelToSnake 會把 snCode2 轉成 sn_code2。
 * 後端欄位是 sn_code_2／sn_code_3，讀寫都在客戶 API 這裡對齊。
 *
 * @param {object|null|undefined} record
 */
export function mapCustomerRecordSnCodes(record) {
  if (record == null || typeof record !== 'object' || Array.isArray(record)) {
    return record;
  }

  const snCode2 = record.snCode2 ?? record.snCode_2 ?? null;
  const snCode3 = record.snCode3 ?? record.snCode_3 ?? null;
  const next = { ...record, snCode2, snCode3 };
  delete next.snCode_2;
  delete next.snCode_3;
  return next;
}

/**
 * @param {object|null|undefined} payload
 */
export function customerWriteBody(payload) {
  const source = payload ?? {};
  const { status: _ignored, snCode2, snCode3, ...rest } = source;
  const body = keysToSnake(rest);

  if (Object.prototype.hasOwnProperty.call(source, 'snCode2')) {
    body.sn_code_2 = snCode2 ?? null;
  }
  if (Object.prototype.hasOwnProperty.call(source, 'snCode3')) {
    body.sn_code_3 = snCode3 ?? null;
  }

  return body;
}
